<template>
  <div class="firstagent-agent">
    <Row>
      <Col :xs="24" :sm="24">
        <Form :model="formItem" ref="formItem" :inline="true" action="javascript:void(0)">
          <FormItem>
            <Input v-model="formItem.key" clearable placeholder="输入关键词查找..."></Input>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="renderTable('formItem')">查找</Button>
          </FormItem>
          <!-- <FormItem>
          <Button type="success" @click="createAgentTradesMan()">新增</Button>
          </FormItem>-->
        </Form>
      </Col>
    </Row>
    <Table border :columns="list" :data="tablelist" :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page
          ref="listPage"
          :total="pages.total"
          :current="pages.page"
          :page-size="pages.size"
          show-elevator
          show-total
          @on-change="changePage()"
        ></Page>
      </div>
    </div>

    <Modal v-model="showModalStatus" title="添加代理商" @on-ok="ok" :width="800">
      <Form :model="search_s" ref="search_s" :inline="true" action="javascript:void(0)">
        <FormItem>
          <Input v-model="search_s.key" clearable placeholder="输入名称查找..."></Input>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="renderTable1('search_s')">查找</Button>
        </FormItem>
      </Form>
      <Table
        border
        :columns="columns2"
        ref="selection"
        :data="columns2List"
        :loading="dataloading"
        @on-selection-change="handleSelectRow()"
      ></Table>
      <div style="margin: 10px;overflow: hidden">
        <div style="float: right;">
          <Page
            ref="listPage1"
            :total="pages1.total"
            :current="pages1.page"
            :page-size="pages1.size"
            show-elevator
            show-total
            @on-change="changePage1()"
          ></Page>
        </div>
      </div>
    </Modal>

    <Modal v-model="showModalStatus" title="添加商户" @on-ok="ok" :width="800">
      <Form :model="search_s" ref="search_s" :inline="true" action="javascript:void(0)">
        <FormItem>
          <Input v-model="search_s.key" clearable placeholder="输入名称查找..."></Input>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="renderTable1('search_s')">查找</Button>
        </FormItem>
      </Form>
      <Table
        border
        :columns="columns2"
        ref="selection"
        :data="columns2List"
        :loading="dataloading"
        @on-selection-change="handleSelectRow()"
      ></Table>
      <div style="margin: 10px;overflow: hidden">
        <div style="float: right;">
          <Page
            ref="listPage1"
            :total="pages1.total"
            :current="pages1.page"
            :page-size="pages1.size"
            show-elevator
            show-total
            @on-change="changePage1()"
          ></Page>
        </div>
      </div>
    </Modal>
    <Modal v-model="showModalStatus3" title="直接支付分销比例" @on-ok="editAgent()" :loading="loading">
      <span style="color:red;">*一级分销商分销二级分销商扫码支付比例</span>
      <Form :model="dataInfo" action="javascript:void(0)" :label-width="80">
        <FormItem label="比例">
          <Input v-model="dataInfo.underline_fx" placeholder="输入直接支付分销比例"></Input>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import UploadThumb from "../common/thumb";
import uploadthumbTwo from "../common/thumb";
export default {
  name: "firstagent-agent",
  data() {
    return {
      id: null, // 页面agentid
      loading: true,
      dataloading: true,
      showModalStatus3: false,
      title: "",
      dataInfo: {
        underline_fx: 100
      },
      pages: {
        page: 1,
        size: 10
      },
      formItem: {
        key: ""
      },
      tablelist1: [],
      columns2: [
        {
          type: "selection",
          width: 100,
          fixed: "left"
        },
        {
          title: "代理商UUID",
          key: "agent_uuid",
          minWidth: 100
        },
        // {
        //     title: '手机号',
        //     key: 'user',
        //     minWidth:100,
        //     render:(h,params) => {
        //         return h('span',params.row.user != null ? params.row.user.username : '')
        //     }
        // },
        {
          title: "名称",
          key: "name",
          minWidth: 160
          // render:(h,params) => {
          //     return h('span',params.row.tradesman != null ? params.row.tradesman.nickname : '')
          // }
        }
      ],
      columns2List: [],
      pages1: {
        page: 1,
        size: 10
      },
      search_s: {},
      list: [
        {
          title: "用户ID",
          key: "agent_uuid",
          minWidth: 350
        },
        // {
        //     title: '用户身份',
        //     key: 'nickname',
        //     minWidth:160,
        //     render:(h,params) => {
        //         return h('span',params.row.tradesman != null ? params.row.tradesman.nickname : '')
        //     }
        // },
        {
          title: "电话",
          key: "username",
          minWidth: 120,
          render: (h, params) => {
            return h(
              "span",
              params.row.user != null && params.row.user.username != null
                ? params.row.user.username
                : ""
            );
          }
        },
        {
          title: "用户名称",
          key: "name",
          minWidth: 200
        },
        {
          title: "操作",
          key: "action",
          width: 300,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(this.id, params.row.agent_uuid);
                    }
                  }
                },
                "删除"
              )
              // h(
              //   "Button",
              //   {
              //     style: {
              //       marginRight: "8px"
              //     },
              //     props: {
              //       type: "info",
              //       size: "small"
              //     },
              //     on: {
              //       click: () => {
              //         this.agentdetail(params.row.agent_uuid);
              //       }
              //     }
              //   },
              //   "提成比例设置"
              // )
            ]);
          }
        }
      ],
      tablelist: [],
      showModalStatus: false
    };
  },
  created: function() {
    this.id = this.$route.params.id;
    this.getTableList();
  },
  components: {
    UploadThumb,
    uploadthumbTwo
  },
  watch: {
    "$route.params.id": function(curVal, oldVal) {
      if (curVal) {
        this.id = curVal;
        this.getTableList();
      }
    }
  },
  methods: {
    getTableList: function() {
      this.$api.firstagent
        .agentlist({
          page: this.pages.page,
          size: this.pages.size,
          id: this.id
        })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.tablelist = res.result.list;
            this.pages.total = res.result.total;
            this.$Message.success(res.msg);
          }
        });
      return;
    },
    // 翻页
    changePage() {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function(name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        key: this.formItem.key,
        page: this.pages.page,
        size: this.pages.size,
        id: this.id
      };
      this.$api.firstagent.agentlist(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    createAgentTradesMan() {
      this.search_s.key = "";
      this.showModalStatus = true;
      this.$api.firstagent.noBindAgents({ id: this.id }).then(res => {
        if (res.code == 200) {
          this.columns2List = res.result.list;
          this.pages1.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
    },
    // 筛选
    renderTable1: function(name) {
      if (name != 1) {
        this.pages1.page = 1;
      }
      this.dataloading = true;
      var ps = {
        key: this.search_s.key,
        page: this.pages1.page,
        size: this.pages1.size,
        id: this.id
      };
      this.$api.firstagent.noBindAgents(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.columns2List = res.result.list;
          this.pages1.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    handleSelectRow(selection, index) {
      this.selected = this.$refs.selection.getSelection();
      console.log(this.selected);
    },
    //选中提交
    ok() {
      this.tablelist1 = this.selected;
      this.$api.firstagent
        .agentCreate({
          first_agent_uuid: this.id,
          agentUuidArrs: this.selected
        })
        .then(res => {
          if (res.code == 200) {
            this.getTableList();
            this.$Message.success(res.msg);
            this.showModalStatus = false;
          } else {
            this.$Message.error(res.msg);
          }
        });
    },
    // 删除
    remove: function(first_agent_uuid, agent_uuid) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.firstagent
            .agentRemove({
              agent_uuid: agent_uuid,
              first_agent_uuid: first_agent_uuid
            })
            .then(res => {
              if (res.code == 200) {
                this.$Message.success(res.msg);
                this.getTableList();
              }
            });
        }
      });
    },
    changePage1() {
      this.pages1.page = this.$refs["listPage1"].currentPage;
      this.renderTable1(1);
    },
    agentdetail(agent_uuid) {
      this.dataInfo = {
        underline_fx: 100,
        on_fx: 100
      };
      this.showModalStatus3 = !this.showModalStatus3;
      this.agent_uuid = agent_uuid;
      this.$api.firstagent
        .agentbili({
          agent_uuid: this.agent_uuid
        })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.dataInfo = res.result;
            this.$Message.success(res.msg);
          }
        });
    },
    editAgent(name) {
      this.dataInfo.agent_uuid = this.agent_uuid;
      this.$api.firstagent.setagentbili(this.dataInfo).then(res => {
        if (res.code == 200) {
          this.renderTable(1);
          this.showModalStatus3 = !this.showModalStatus3;
        }
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true;
        });
      });
    }
  }
};
</script>

<style>
.demo-drawer-footer {
  width: 100%;
  height: 50px;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
</style>
